"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var Tooltip_1 = require("./Tooltip");
var TooltipContent_1 = require("./TooltipContent");
__export(require("./Tooltip"));
__export(require("./TooltipContent"));
var TooltipModule = (function () {
    function TooltipModule() {
    }
    TooltipModule.decorators = [
        { type: core_1.NgModule, args: [{
                    imports: [
                        common_1.CommonModule
                    ],
                    declarations: [
                        Tooltip_1.Tooltip,
                        TooltipContent_1.TooltipContent,
                    ],
                    exports: [
                        Tooltip_1.Tooltip,
                        TooltipContent_1.TooltipContent,
                    ],
                    entryComponents: [
                        TooltipContent_1.TooltipContent
                    ]
                },] },
    ];
    /** @nocollapse */
    TooltipModule.ctorParameters = function () { return []; };
    return TooltipModule;
}());
exports.TooltipModule = TooltipModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-tooltip/index.js
// module id = 241
// module chunks = 1